/**
 * @desc 登记事件
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.TheNewEventParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/event/add',
    data,
  });
}

export function mock(
  data: defs.TheNewEventParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/event/add',
    data,
  });
}
